export const GitHubButton = () => (
	<a class="btn btn-link" href={HOMEPAGE} target="_blank">
		<img src="/static/github.svg" alt="GitHub" width="24" height="24" />
	</a>
)
